import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';

Injectable()
export class Globals {
    LOCAL_STORE = 'MicroBrokerMobileStore';
    USER_SESSION_KEY = '_userSession';
    CRYPTO_KEY = 'P@$$w0rd';
    MSG_CONNECTION = 'Connexion...';
    MSG_LOGOUT = 'Déconnexion...';
    MSG_INIT = 'Initialisation...';
    MSG_ACTIVE_ACCOUNT = 'Mise à jour du compte actif...';
    MSG_CONNECTION_ERROR = 'Erreur de connexion! Veuillez vérifier votre login et mot de passe.';
    MSG_UNKNOWN_ERROR = 'Erreur système inconnue!';
    MSG_COMMUNICATION_ERROR = 'Échec de chargement des données. Vérifiez votre connexion internet puis actualisez la page.';
    MSG_STORAGE_ERROR = 'Erreur de stockage interne!';
    MSG_ORDER_CANCEL_CONFIRM = 'Vous êtes sur le point d\'annuler l\'ordre,<br/>Voulez-vous confirmer?';
    MSG_ORDER_ADD_CONFIRM = 'Vous êtes sur le point d\'envoyer l\'ordre,<br/>Voulez-vous confirmer?';
    MSG_ORDER_REPLACE_CONFIRM = 'Vous êtes sur le point de modifier l\'ordre,<br/>Voulez-vous confirmer?';

    public showUnknownError(toastCtrl: ToastController, error: any) {
        let toast = toastCtrl.create({
            message: this.MSG_UNKNOWN_ERROR,
            duration: 5000,
            cssClass: 'errorToast',
            showCloseButton: true,
            closeButtonText: 'Fermer'
        });
        toast.present();
        console.log(error);
    }

    public showCommunicationError(toastCtrl: ToastController, error: any) {
        let toast = toastCtrl.create({
            message: this.MSG_COMMUNICATION_ERROR,
            duration: 5000,
            cssClass: 'errorToast',
            showCloseButton: true,
            closeButtonText: 'Fermer'
        });
        toast.present();
        console.log(error);
    }

    public showStorageError(toastCtrl: ToastController, error: any) {
        let toast = toastCtrl.create({
            message: this.MSG_STORAGE_ERROR,
            duration: 5000,
            cssClass: 'errorToast',
            showCloseButton: true,
            closeButtonText: 'Fermer'
        });
        toast.present();
        console.log(error);
    }

    public showInfo(toastCtrl: ToastController, message: string) {
        let toast = toastCtrl.create({
            message: message,
            duration: 5000,
            cssClass: 'infoToast',
            showCloseButton: true,
            closeButtonText: 'Fermer'
        });
        toast.present();
    }

    public showError(toastCtrl: ToastController, message: string) {
        let toast = toastCtrl.create({
            message: message,
            duration: 5000,
            cssClass: 'errorToast',
            showCloseButton: true,
            closeButtonText: 'Fermer'
        });
        toast.present();
    }

    public showConfirm(toastCtrl: ToastController, message: string) {
        let toast = toastCtrl.create({
            message: message,
            duration: 5000,
            cssClass: 'confirmToast',
            showCloseButton: true,
            closeButtonText: 'Fermer'
        });
        toast.present();
    }

    public isToday(date: Date) {
        let today = new Date();
        let isToday: boolean = (date.getFullYear() == today.getFullYear()) && (date.getMonth() == today.getMonth()) && (date.getDay() == today.getDay());
        return isToday;
    }
}


// WEBPACK FOOTER //
// ./src/app/globals.ts